import React from "react";
import { useTranslation } from "react-i18next";

export default function OurStorySection() {
  const { t } = useTranslation();
  return (
    <section className="bg-[#f6fcff] px-6 pb-20 text-center">
      <div className="mx-auto max-w-4xl">
        <h2 className="font-arya text-4xl font-extrabold tracking-tight text-gray-900">
          {t("about.story.title")}
        </h2>
        <h3 className="mt-6 text-2xl font-bold text-green-800">
          {t("about.story.subtitle")}
        </h3>
        <p className="mt-8 text-md leading-8 text-gray-600">
          {t("about.story.para1")}
        </p>
        <p className="mt-6 text-md leading-8 text-gray-600">
          {t("about.story.para2")}
        </p>
      </div>
    </section>
  );
}
